// extracted by mini-css-extract-plugin
export default {"bank":"item_bank__yZMnF","content":"item_content__qGYsA","short":"item_short__lYwsQ","box":"item_box__7mrxS","row":"item_row__Kwa8H","item":"item_item__7jjFU"};